module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/167-macao-3eb04d65838c0b1e1b6a3d4bb4ed5a2b.svg";